import { render, staticRenderFns } from "./LogisticaConferenciaRemessa.vue?vue&type=template&id=1cea34ce&scoped=true"
import script from "./LogisticaConferenciaRemessa.vue?vue&type=script&lang=js"
export * from "./LogisticaConferenciaRemessa.vue?vue&type=script&lang=js"
import style0 from "./LogisticaConferenciaRemessa.vue?vue&type=style&index=0&id=1cea34ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cea34ce",
  null
  
)

export default component.exports